import axios from "axios";

import Token from "../../utilities/jwt/Token.js";

export default class TipoService extends Token {
  
  findAll() {
    return axios({
      method: "get",
      url: this.api_url + "tipo",
      withCredentials: true,
    }).then((res) => res.data);
  }

  create(data) {
    return axios({
      method: "post",
      url: this.api_url + "tipo",
      withCredentials: true,
      data: data,
    });
  }
  
  update(data) {
    return axios({
      method: 'put',
      url: this.api_url + 'tipo/' + data.id,
      withCredentials: true,
      data: data,
    });

  }

  delete(id) {
    return axios({
      method: 'delete',
      url: this.api_url + 'tipo/' + id,
      withCredentials: true,
    });

  }
}
